import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { usePageTitle } from '../hooks/usePageTitle';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ContentPage({ pageKey }) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios.get(`${API_URL}/content`)
      .then((r) => { if (active) setPage(r.data[pageKey]); })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [pageKey]);

  usePageTitle(page?.title || 'Information');

  return (
    <div className="page-transition" data-testid={`content-page-${pageKey}`}>
      <section className="bg-[#0B1120] py-14 text-center px-4">
        <h1 className="text-4xl sm:text-5xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
          {page?.title || (loading ? '' : 'Information')}
        </h1>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <p className="text-muted-foreground text-center">Loading...</p>
        ) : (
          <div className="prose max-w-none text-gray-700 whitespace-pre-line leading-relaxed" data-testid="content-body">
            {page?.content}
          </div>
        )}
      </div>
    </div>
  );
}
